import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

import styles from "./index.module.css";

import SingleItem from "./SingleItem";

const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

const Carousel = ({ children, onPaginate }) => {
  // carousel pagination
  const [[page, direction], setPage] = useState([0, 0]);

  const variants = {
    enter: direction => ({
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
      transition: { delay: 0.4 }
    },
    exit: direction => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 1
    })
  };

  const paginate = newDirection => {
    setPage([page + newDirection, newDirection]);
    onPaginate && onPaginate(newDirection);
  };

  return (
    <AnimatePresence initial={false} custom={direction}>
      <motion.div
        key={page}
        className={styles.container}
        custom={direction}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        drag="x"
        dragConstraints={{ left: 0, right: 0 }}
        dragElastic={1}
        onDragEnd={(e, { offset, velocity }) => {
          const swipe = swipePower(offset.x, velocity.x);

          if (swipe < -swipeConfidenceThreshold) {
            paginate(1);
          } else if (swipe > swipeConfidenceThreshold) {
            paginate(-1);
          }
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

const CarouselComponent = ({
  allData,
  onModal,
  data,
  onPaginate,
  ...props
}) => {
  // for toggling navigation bar
  useEffect(() => {
    console.log("setting modal to true!");
    onModal && onModal(true);
    return () => onModal && onModal(false);
  }, []);

  return (
    <Carousel onPaginate={onPaginate}>
      <SingleItem data={data} {...props} />
    </Carousel>
  );
};

export default CarouselComponent;
